module.exports = __webpack_public_path__ + "static/media/how_to_play.d1fc0b7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/movie/how_to_play.mp4
// module id = om+O
// module chunks = 1